//import axios from 'axios'
import axios from './axiosConfig'


export default {

    /**
     * Sends the data entered by the user to the create Project Controller.
     *
     */
    async login(payload) {
        axios.post('/login/keycloak', payload)
            .then(response => {
                return response.data;
            }).catch(error => {
                return error;
            });
    },

    /**
     * Receives the project data from the return project controller
     *
     */
    async logout(payload) {
        return axios.post('/logout/keycloak', payload)
            .then(response => {
                return response.data;
            }).catch(error => {
                this.loaded = true;
                if (error.response.status === 422) {
                    console.log(error.response.data.errors);
                }
            });
    },
    async refreshSession() {
        return axios.post('/user/refresh')
            .then(response => {
                return response.data;
            });
    },
    async returnAccessToken() {
        return axios.post('/user/access/token')
            .then(response => {
                return response.data;
            });
    },
}
